import { EventData, TRACKING, TrackingEvent } from '@/helpers/tracking';

import {
  EMBED_CLOSED_MESSAGE,
  EMBED_HOST_INSTALLER_CONNECTED_MESSAGE,
  EMBED_OPENED_MESSAGE,
  EMBED_QUESTION_MESSAGE,
  EmbedMessage,
} from './messages';

// Maps Aurora funnel track events → partner-page postMessage payloads. Keep partner event names
// stable here even if TRACKING keys change.
const HOST_EVENT_BY_TRACKING: Partial<Record<TrackingEvent, string>> = {
  [TRACKING.EMBED_CLOSED_MODAL]: EMBED_CLOSED_MESSAGE,
  [TRACKING.EMBED_OPENED_MODAL]: EMBED_OPENED_MESSAGE,
};

const QUESTION_BY_TRACKING: Partial<Record<TrackingEvent, string>> = {
  [TRACKING.SUBMIT_ANSWER_ADDRESS]: 'address',
  [TRACKING.SUBMIT_ANSWER_BILL]: 'bill',
  [TRACKING.SUBMIT_ANSWER_UTILITY_PROVIDER]: 'utility',
};

const mapTrackingToMessage = (
  eventName: TrackingEvent,
  eventData: EventData | undefined,
  embedPartnerId: string | undefined
): EmbedMessage | null => {
  const hostEvent = HOST_EVENT_BY_TRACKING[eventName];
  if (hostEvent) {
    return { type: hostEvent };
  }

  const question = QUESTION_BY_TRACKING[eventName];
  if (question) {
    return { question, type: EMBED_QUESTION_MESSAGE };
  }

  if (eventName === TRACKING.INSTALLER_CONNECTED) {
    const { installerId } = eventData ?? {};
    if (embedPartnerId != null && installerId != null && String(installerId) === String(embedPartnerId)) {
      return { type: EMBED_HOST_INSTALLER_CONNECTED_MESSAGE };
    }
  }

  return null;
};

export const publishFromTracking = (
  eventName: TrackingEvent,
  eventData: EventData | undefined,
  embedPartnerId: string | undefined
) => {
  const message = mapTrackingToMessage(eventName, eventData, embedPartnerId);
  if (message) {
    window.parent.postMessage(message, '*');
  }
};
